function MoneyIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg width={size} height={(size * 21) / 20} viewBox='0 0 20 21' fill='currentColor'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.0354 8.44036C16.2764 7.69576 16.667 6.89926 16.667 6.33398C16.667 5.7687 16.2764 4.97221 15.0354 4.22761C13.8276 3.50291 12.0514 3.00065 10.0003 3.00065C7.94927 3.00065 6.17309 3.50291 4.96526 4.22761C3.72426 4.97221 3.33366 5.7687 3.33366 6.33398C3.33366 6.89926 3.72426 7.69576 4.96526 8.44036C6.17309 9.16506 7.94927 9.66732 10.0003 9.66732C12.0514 9.66732 13.8276 9.16506 15.0354 8.44036ZM10.0003 11.334C14.6027 11.334 18.3337 9.09541 18.3337 6.33398C18.3337 3.57256 14.6027 1.33398 10.0003 1.33398C5.39795 1.33398 1.66699 3.57256 1.66699 6.33398C1.66699 9.09541 5.39795 11.334 10.0003 11.334Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.10173 12.7178C6.31333 13.3909 8.04361 13.8333 10.0003 13.8333C11.957 13.8333 13.6873 13.3909 14.8989 12.7178C16.1388 12.029 16.667 11.2105 16.667 10.5H18.3337C18.3337 12.0907 17.183 13.3555 15.7083 14.1747C14.2055 15.0097 12.1858 15.5 10.0003 15.5C7.8149 15.5 5.79518 15.0097 4.29232 14.1747C2.81769 13.3555 1.66699 12.0907 1.66699 10.5H3.33366C3.33366 11.2105 3.86189 12.029 5.10173 12.7178Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.10173 16.8838C6.31333 17.5569 8.04361 17.9993 10.0003 17.9993C11.957 17.9993 13.6873 17.5569 14.8989 16.8838C16.1388 16.195 16.667 15.3765 16.667 14.666H18.3337C18.3337 16.2567 17.183 17.5215 15.7083 18.3408C14.2055 19.1757 12.1858 19.666 10.0003 19.666C7.8149 19.666 5.79518 19.1757 4.29232 18.3408C2.81769 17.5215 1.66699 16.2567 1.66699 14.666H3.33366C3.33366 15.3765 3.86189 16.195 5.10173 16.8838Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.66634 14.6673L1.66634 6.33398L3.33301 6.33398L3.33301 14.6673L1.66634 14.6673Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M16.6663 14.6673L16.6663 6.33398L18.333 6.33398L18.333 14.6673L16.6663 14.6673Z'
        />
      </svg>
    </span>
  );
}

export default MoneyIcon;
